import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "#EDFEF6",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.6279 10.9147C21.6175 10.8076 21.5947 10.702 21.5599 10.6002C21.5083 10.4803 21.4396 10.3686 21.3558 10.2686L12.4285 0.788659C12.2436 0.603828 11.9928 0.5 11.7314 0.5C11.4699 0.5 11.2191 0.603828 11.0342 0.788659C10.8585 0.985067 10.7614 1.23933 10.7614 1.50284C10.7614 1.76635 10.8585 2.02062 11.0342 2.21702L18.4651 10.005H1.52026C1.24967 10.005 0.990163 10.1125 0.798827 10.3038C0.607491 10.4952 0.5 10.7547 0.5 11.0253C0.5 11.2959 0.607491 11.5554 0.798827 11.7467C0.990163 11.938 1.24967 12.0455 1.52026 12.0455H18.4566L11.0342 19.791C10.8655 19.9858 10.7726 20.2348 10.7726 20.4924C10.7726 20.7501 10.8655 20.9991 11.0342 21.1939C11.1221 21.2914 11.2297 21.369 11.3499 21.4218C11.4701 21.4746 11.6001 21.5012 11.7314 21.4999C11.8639 21.5013 11.9952 21.4748 12.1168 21.4221C12.2384 21.3693 12.3475 21.2916 12.437 21.1939L21.3558 11.6714C21.4486 11.5766 21.521 11.4638 21.5684 11.3399C21.6049 11.2443 21.6278 11.1442 21.6364 11.0423L21.6279 10.9147Z",
		fill: "inherit"
	})
});
export { SvgArrowRight as ReactComponent };
